export default {
  colors: {
    default: "#344675",
    primary: "#42b883",
    info: "#243024",
    danger: "#243024",
    teal: "#00d6b4",
    primaryGradient: [
      "rgba(2, 0, 32, 0.1)",
      "rgba(2, 0, 32, 0)",
      "rgba(2, 0, 32,0)",
    ],
  },
};
